const form = {
  formId: "new-user-form",
  formField: {
    numberContract: {
      name: "numberContract",
      label: "[01] Kỳ tính thuế: Quyết toán hợp đồng số:",
      type: "text",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn quyết toán hợp đồng số",
    },
    date: {
      name: "date",
      label: "Ngày:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
    startDate: {
      name: "startDate",
      label: "Ngày bắt dầu:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày bắt đầu",
    },
    endDate: {
      name: "endDate",
      label: "Ngày kết thúc:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày kết thúc",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxAlternatePayerName: {
      name: "taxAlternatePayerName",
      label: "[04] Bên Việt Nam khấu trừ và nộp thuế thay:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập Bên Việt Nam khấu trừ và nộp thuế thay",
    },
    taxAlternatePayerId: {
      name: "taxAlternatePayerId",
      label: "[05] Mã số thuế nộp thay của Bên Việt Nam:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế nộp thay của Bên Việt Nam",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[06] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "",
    },
    taxId: {
      name: "taxId",
      label: "[07] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgentContract: {
      name: "taxAgentContract",
      label: "[08] Hợp đồng đại lý thuế: Số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập hợp đồng đại lý thuế: Số",
    },
    taxAgentContractDate: {
      name: "taxAgentContractDate",
      label: "Ngày:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },

    taxAlternatePayerName3: {
      name: "taxAlternatePayerName3",
      label: "Bên Việt Nam khấu trừ và nộp thuế thay:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập Bên Việt Nam khấu trừ và nộp thuế thay",
    },
    taxAlternatePayerId3: {
      name: "taxAlternatePayerId3",
      label: "Mã số thuế nộp thay của Bên Việt Nam:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế nộp thay của Bên Việt Nam",
      invalidMsg: "Mã số thuế không hợp lệ",
    },

    taxAlternatePayerName2: {
      name: "taxAlternatePayerName2",
      label: "Bên Việt Nam khấu trừ và nộp thuế thay:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập Bên Việt Nam khấu trừ và nộp thuế thay",
    },
    taxAlternatePayerId2: {
      name: "taxAlternatePayerId2",
      label: "Mã số thuế nộp thay của Bên Việt Nam:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế nộp thay của Bên Việt Nam",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
  },
};

export default form;
